var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "t-tags t-container" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.scrollTags > 0
          ? _c(
              "div",
              {
                staticClass: "t-tags__arrow _left",
                on: { click: _vm.scrollToLeft }
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "6",
                      height: "12",
                      viewBox: "0 0 6 12",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d:
                          "M5.81304 5.49489L0.902746 0L0 1.01022L4.45892 6L0 10.9898L0.902746 12L5.81304 6.50511C6.06232 6.22615 6.06232 5.77385 5.81304 5.49489Z",
                        fill: "#929292"
                      }
                    })
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "tags",
          staticClass: "t-tags__container t-dfc",
          on: { scroll: _vm.changeScroll }
        },
        _vm._l(_vm.tags, function(item, index) {
          return _c(
            "div",
            {
              key: "tags-item-" + index,
              staticClass: "t-tags__item",
              class: { _active: _vm.checked[index] === item.id },
              on: {
                click: function($event) {
                  return _vm.toggleTags(index, item.id)
                }
              }
            },
            [
              _c("span", { staticClass: "t-tags__name" }, [
                _vm._v(_vm._s(item.name))
              ])
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }